import { Check, CheckCircle2 } from "lucide-react";
import { STEP_NAMES } from "@/components/site/serviceContent";

export const OfferGrid = ({ content }) => (
  <section data-testid="service-offer-section" className="border-t border-brand-surface bg-brand-offwhite py-20 lg:py-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="eyebrow">What We Offer</p>
      <h2 className="h2 mt-4 max-w-2xl">{content.offerTitle}</h2>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {content.features.map(({ icon: Icon, title, desc }, i) => (
          <div key={title} data-testid={`service-feature-${i}`} className="soft-card p-7 transition-shadow duration-300 hover:shadow-md">
            <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-offwhite">
              <Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
            </span>
            <h3 className="mt-5 font-heading text-lg font-semibold text-brand-navy">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-brand-slate">{desc}</p>
          </div>
        ))}
      </div>
      <div className="soft-card mt-10 p-7 sm:p-9" data-testid="service-specs">
        <h3 className="font-heading text-base font-semibold text-brand-navy">Technical details</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {content.specs.map((s, i) => (
            <li key={s} data-testid={`service-spec-${i}`} className="flex items-start gap-2.5 text-sm text-brand-slate">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" strokeWidth={2.25} /> {s}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export const Benefits = ({ content }) => (
  <section data-testid="service-benefits-section" className="bg-brand-navy py-20 text-white lg:py-24">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <div>
        <p className="eyebrow eyebrow-light">Why It Matters</p>
        <h2 className="mt-4 font-heading text-[1.75rem] font-semibold leading-tight tracking-tight sm:text-4xl">{content.benefitsTitle}</h2>
      </div>
      <ul className="grid gap-5 sm:grid-cols-2">
        {content.benefits.map((b, i) => (
          <li key={b.title} data-testid={`service-benefit-${i}`} className="rounded-xl border border-white/10 bg-brand-deep p-6">
            <CheckCircle2 className="h-6 w-6 text-brand-cyan" strokeWidth={1.6} />
            <h3 className="mt-4 font-heading text-base font-semibold">{b.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/70">{b.desc}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export const Steps = ({ content }) => (
  <section data-testid="service-steps-section" className="bg-white py-20 lg:py-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="eyebrow">How It Works</p>
      <h2 className="h2 mt-5">Four Simple Steps to Get Started</h2>
      <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEP_NAMES.map((name, i) => (
          <li key={name} data-testid={`service-step-${i}`} className="relative rounded-xl border border-brand-surface bg-brand-surface/40 p-6">
            <span className="font-heading text-3xl font-semibold text-brand-blue">0{i + 1}</span>
            <h3 className="mt-4 font-heading text-base font-semibold text-brand-navy">{name}</h3>
            <p className="mt-2 text-sm leading-relaxed text-brand-slate">{content.steps[i]}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
